// src/components/Features.js
import React from "react";
import { motion } from "framer-motion";
import Tilt from "react-parallax-tilt";
import "./containerlan.css";
import c01 from "../Images/c01.jpg";
import c02 from "../Images/c02.jpg";
import c03 from "../Images/c03.jpg";
import c04 from "../Images/c04.jpg";
import c05 from "../Images/c05.jpg";
import c06 from "../Images/c06.jpg";
import { Link } from 'react-router-dom';

const features = [
  {
    title: "AI Skills Assessment",
    description: "Gain hands-on experience with realistic AI-driven mock interviews designed to boost your confidence.",
    image: c01,
  },
  {
    title: "AI Mock Interview",
    description: "Experience real-time AI-powered mock interviews tailored to your domain.",
    image: c02,
  },
  {
    title: "AI Resume Builder",
    description: "Build professional resumes using AI suggestions, keyword optimization, and design templates.",
    image: c03,
  },
  {
    title: "ATS Recommendation",
    description: "Optimize your resume with smart AI recommendations for ATS success.",
    image: c04,
  },
  {
    title: "Employer Portal",
    description: "Employers can post jobs, view AI-ranked candidates, and connect directly with top talents.",
    image: c05,
  },
  {
    title: "Mentorship",
    description: "Get career guidance from industry experts through one-on-one mentorship sessions.",
    image: c06,
  },
];

const containerVariants = {
  hidden: { opacity: 0 },
  show: {
    opacity: 1,
    transition: {
      staggerChildren: 0.3,
    },
  },
};

const cardVariants = {
  hidden: { opacity: 0, y: 60 },
  show: { opacity: 1, y: 0, transition: { duration: 0.8, ease: "easeOut" } },
};

const Features = () => {
  return (
    <motion.div
      className="features-section"
      initial="hidden"
      whileInView="show"
      variants={containerVariants}
      viewport={{ once: true, amount: 0.2 }}
    >
      <motion.h2
        className="features-heading"
        initial={{ y: -40, opacity: 0 }}
        whileInView={{ y: 0, opacity: 1 }}
        transition={{ duration: 1, ease: "easeOut" }}
      >
        Empowering You to <span>Learn, Grow, and Succeed</span> Seamlessly
      </motion.h2>

      <div className="features-grid">
        {features.map((feature, idx) => (
          <motion.div
            key={idx}
            className="motion-card"
            variants={cardVariants}
            whileHover={{ scale: 1.03 }}
            transition={{ type: "spring", stiffness: 200 }}
          >
            <Tilt
              tiltMaxAngleX={15}
              tiltMaxAngleY={15}
              glareEnable={true}
              glareColor="#ffffff"
              glarePosition="bottom"
            >
              <div className="feature-card">
                <div className="feature-inner">
                  <div className="feature-image">
                    <img src={feature.image} alt={feature.title} />
                  </div>
                  <div className="feature-info">
                    <h3>{feature.title}</h3>
                    <p>{feature.description}</p>
                    <Link to="/SignupForm"> <motion.button
                      className="feature-btn"
                      whileHover={{ scale: 1.1 }}
                      transition={{ duration: 0.3 }}
                    >
                      Try Now ➜
                    </motion.button></Link>
                  </div>
                </div>
              </div>
            </Tilt>
          </motion.div>
        ))}
      </div>
    </motion.div>
  );
};

export default Features;
